import { parsePhoneNumberFromString } from 'libphonenumber-js';

const DEFAULT_REGION = 'AR';

export const normalizeEmail = (value?: string): string | undefined => {
  if (!value) return undefined;
  const trimmed = value.trim();
  return trimmed ? trimmed.toLowerCase() : undefined;
};

export const normalizePhone = (value?: string): string | null => {
  if (!value) return null;

  // Handle Argentine numbers (+54): ensure they have a 9 after the country code
  let processedValue = value.trim();
  if (processedValue.startsWith('+54')) {
    // Extract the part after +54
    const afterCountryCode = processedValue.substring(3);
    // If the next character is not a 9, add it
    if (afterCountryCode.length > 0 && !afterCountryCode.startsWith('9')) {
      processedValue = '+549' + afterCountryCode;
    }
  }

  const parsed = parsePhoneNumberFromString(processedValue, DEFAULT_REGION);
  if (parsed && parsed.isValid()) {
    return parsed.number;
  }
  const fallback = parsePhoneNumberFromString(processedValue);
  if (fallback && fallback.isValid()) {
    return fallback.number;
  }
  return null;
};

export const isValidPhone = (value?: string): boolean => normalizePhone(value) !== null;
